import { Inbox } from 'lucide-react';
import { InboxRouteView, InboxConversationRouteView } from './routes/inbox-page.js';
export const conversationsModule = {
    id: 'conversations',
    label: 'Inbox',
    icon: Inbox,
    permission: 'conversations.list',
    workspace: 'support',
    order: 10,
    description: 'Customer messages unified across all channels.',
    routes: [
        { path: '/', component: InboxRouteView },
        { path: '/$conversationId', component: InboxConversationRouteView },
    ],
};
export { InboxRouteView, InboxConversationRouteView } from './routes/inbox-page.js';
// Declared in `./perms.js` rather than here: the route components consume the
// context at runtime, so declaring it in this barrel would make index → route →
// index a real import cycle. The shell's entry point is unchanged.
export { ConversationsModulePermsProvider, CONVERSATIONS_PERMS_NONE, } from './perms.js';
export { setConversationsApiBaseUrl, deleteComment } from './api.js';
// Один попап на создание/правку комментария — переиспользуется страницей
// «Комментарии» модуля annotations через этот публичный вход.
export { CommentDialog, CommentFormSchema, commentErrorMessage, } from './forms/comment-dialog.js';
export { bulkSelection } from './hooks/use-bulk-selection.js';
export { INBOX_FILTERS_KEY, INBOX_LAST_CONVERSATION_KEY, } from './hooks/use-conversation-status-mutation.js';
// Предустановка фильтров инбокса из другого раздела (страница тегов →
// «показать диалоги»): инбокс читает фильтры из localStorage, не из адреса.
export { presetInboxFilters } from './inbox-filters-preset.js';
//# sourceMappingURL=index.js.map